"use strict";
const focusevents = require("../global/focusevents");
const $body = $("body");

function cellHoverInHighlight(){
    const $td = $(this);
    const colIndex = $td.index();
    const isGenericGuide = $("#sizeGuideModal").hasClass("generic-guide");

    if (window.mqRespond.status.lgDown || (!isGenericGuide && colIndex === 0)) {
        return;
    }

    // highlight row if not a generic guide, as generic guides only have one row of data and highlighting the row would not make a difference
    if (!isGenericGuide) {
        $td.parent().addClass("highlight-row");
    }

    $td.closest("table").find("tr").each(function(index) {
        if (isGenericGuide) {
            $(this).children().eq(colIndex).addClass("highlight-col");
        } else if (index > 0) {
            $(this).children().eq(index === 1 ? colIndex - 1 : colIndex).addClass("highlight-col");
        }
    });

    $td.addClass("highlight-cell");
}

function cellHoverOutHighlight() {
    const $td = $(this);

    if (window.mqRespond.status.lgDown) {
        return;
    }

    $td.parent().removeClass("highlight-row");
    $td.closest("table").find(".highlight-col").removeClass("highlight-col");
    $td.removeClass("highlight-cell");
}

function cellClickHighlight() {
    const $td = $(this);
    const colIndex = $td.index();
    const isClicked = $td.hasClass("highlight-cell");
    const isGenericGuide = $("#sizeGuideModal").hasClass("generic-guide");

    if (!window.mqRespond.status.lgDown || (!isGenericGuide && colIndex === 0)) {
        return;
    }

    $td.closest("table").find(".highlight-row").removeClass("highlight-row");
    $td.closest("table").find(".highlight-col").removeClass("highlight-col");
    $td.closest("table").find(".highlight-cell").removeClass("highlight-cell");

    if (isClicked) {
        return;
    }

    // highlight row if not a generic guide, as generic guides only have one row of data and highlighting the row would not make a difference
    if (!isGenericGuide) {
        $td.parent().addClass("highlight-row");
    }

    // highlight column
    $td.closest("table").find("tr").each(function(index){
        if (isGenericGuide) {
            $(this).children().eq(colIndex).addClass("highlight-col");
        } else if (index > 0) {
            $(this).children().eq(index === 1 ? colIndex - 1 : colIndex).addClass("highlight-col");
        }
    });

    // highlight cell stronger
    $td.addClass("highlight-cell");
}

function initSizeGuideEvents() {
    $body.on("shown.bs.tab", "#sizeGuideModal .nav-link", function() {
        let detailID = $(this).data("toggle-details-id");
        let $detailToActive = $(`#${detailID}`);

        $detailToActive.siblings().removeClass("active");
        $detailToActive.addClass("active");
        
        checkToggleButtonVisibility($(this).attr("href"));
    });

    $body.on("change", "#sizeGuideModal .js-toggle-size-guide-metrics", function() {
        $("#sizeGuideModal").toggleClass("show-in-inches", $(this).is(":checked"));
    });

    $body.on("mouseenter", "#sizeGuideModal .js-size-guide-modal-tables td", cellHoverInHighlight);

    $body.on("mouseleave", "#sizeGuideModal .js-size-guide-modal-tables td", cellHoverOutHighlight);

    $body.on("click", "#sizeGuideModal .js-size-guide-modal-tables td", cellClickHighlight);

    $body.on("shown.bs.modal", "#sizeGuideModal", function() {
        focusevents.initFocusTrap($(this));
        checkToggleButtonVisibility();
    });

    $body.on("hidden.bs.modal", "#sizeGuideModal", function() {
        focusevents.destroyFocusTrap();
        $(".js-detailed-size-guide").trigger("focus");
    });
}

function checkToggleButtonVisibility(targetSelector) {
    // check if the size guide modal has any imperial tables, if not, add a class to hide the toggle button
    let $modal = $("#sizeGuideModal");

    if ($modal.find(".in-imperial").length === 0 ) {
        $modal.toggleClass("generic-guide", true);
    }

    // ensure that the toggle button is hidden if the active tab has no table content
    let contentSelector = targetSelector ? targetSelector : $body.find("#sizeGuideModal nav-link.active").attr("href");
    $(".m-size-guide-modal__switches").toggleClass("d-none", $(`${contentSelector} table`).length === 0);
}

module.exports = {
    // initialize size guide popin events
    init: function () {
        initSizeGuideEvents();
    }
};
